<template>
  <v-main class="page-library page-library-main">
    <AppBar hide-back title="도서관">
      <template #end>
        <v-btn icon plain :ripple="false" @click="librarySearch()">
          <IconSearch/>
        </v-btn>
        <v-btn icon plain :ripple="false"
               class="me-n3"
               to="/fo/library/interest">
          <i class="cu-icon-interest on"></i>
        </v-btn>
      </template>
    </AppBar>
    <!-- 추천 콘텐츠 추가 :: 명상과 이완과 같은 콘텐츠 노출됨 (대충 아무거나 뿌림) -->
    <Flicking ref="flickings"
              :options="{ circular: true }"
              :plugins="plugins"
              @changed="(item) => suggestIndex = item.index"
    >
      <template v-for="(item, j) in recommendedLibList">
        <v-card :key="j"
                width="100%"
                elevation="0"
                class="suggest-card"
                :class="{ active: suggestIndex === j }"
                :to="`/fo/library/suggest/${item.recomContentsId}`"
        >
          <LoadImage :aspect-ratio="8/3"
                     :src="$downUrl(item.bannderImgName)"
          >
<!--            <div class="suggest-card-caption">-->
<!--              <b class="tit">{{ item.title }}</b>-->
<!--              <br /><br />-->
<!--              <span class="txt" v-html="item.contents"></span>-->
<!--            </div>-->
          </LoadImage>
        </v-card>
      </template>
      <div slot="viewport" class="flicking-pagination"></div>
    </Flicking>
    <!-- // 추천 콘텐츠 -->
    <v-container fluid>
      <div class="library-category-lists">
        <Loading v-if="isLoading" :isLoading="isLoading"/>
        <!-- 리스트 없는 경우 -->
        <NoData v-else-if="sbitems.length === 0"/>
        <!-- 리스트 있는 경우 -->
        <template v-else>
          <!--  신규 콘텐츠  -->
          <div class="library-category-lists-item">
            <div class="library-title-block">
<!--              <h2 class="tit" v-text="`신규 콘텐츠 (${newitems.length})` "></h2>-->
              <h2 class="tit">신규 콘텐츠</h2>
            </div>
            <Flicking ref="flickings" :options="flickingOptions">
              <template v-for="(item, j) in newitems">
                <LibraryItem :item="item" :key="`item_${j}`"/>
              </template>
            </Flicking>
          </div>
          <!--  // 신규 콘텐츠  -->
          <!--  주제별 콘텐츠  -->
          <div class="library-category-lists-item" v-for="(sbitem, i) in sbitems" :key="`subject_${i}`">
            <div class="library-title-block">
              <h2 class="tit">
                {{ sbitem.subjectNm }}
<!--                <span class="primary&#45;&#45;text">{{ sbitem.subjectCount }}</span>-->
              </h2>
              <v-btn text :ripple="false"
                     class="btn-allView"
                     @click="goSubjectDetail(sbitem.subject, sbitem.subjectNm)"
                     v-if="sbitem.subject !== '08'"
              >전체보기<i class="ez-dms-arr-right-md ms-2"></i></v-btn>
            </div>
            <Flicking ref="flickings" :options="flickingOptions">
              <template v-for="(item, j) in items">
                <LibraryItem v-if="sbitem.subject === item.subject"
                             :item="item" :key="`item_${j}`"/>
              </template>
            </Flicking>
          <!--  //  주제별 콘텐츠  -->
          </div>
        </template>
      </div>
    </v-container>
    <BottomMenu :current="1"/>
  </v-main>
</template>

<script>
import store from '@/store'
import IconSearch from '@/components/icons/Search'
import BottomMenu from '@/components/layout/BottomMenu'
import LibraryItem from './LibraryItem.vue'
import { Pagination, Fade, AutoPlay } from "@egjs/flicking-plugins";
export default {
  name: 'LibraryMain',
  components: {
    IconSearch,
    BottomMenu,
    LibraryItem
  },
  data: () => ({
    subjectLimit: 20, // 주제별 갯수 제한
    isLoading: false,
    sbitems: [],
    items: [],
    newitems: [],
    recommendedLibList: [],
    suggestIndex: 0,
    flickingOptions: {
      align: 'prev',
      moveType: 'freeScroll',
      circularFallback: "bound",
      circular: false,
      bound: true
    },
    plugins: [
      new Fade(null, .7),
      new AutoPlay({ duration: 10000, direction: "NEXT", stopOnHover: false }),
      new Pagination({ type: 'bullet' })
    ]
  }),
  computed: {
  },
  created() {
    this.newContList()
    this.readList()
    this.getRecommendedLibList()
  },
  activated () {
    if (this.$refs.flickings) {
      this.$refs.flickings.forEach(item => {
        item.destroy()
        item.init()
      })
    }
  },
  deactivated () {},
  methods: {
    ready (e) {
      console.log(e)
    },
    async goSubjectDetail(subjectVal, subjectName) {
      await this.$router.push({
        name: '도서관 상세',
        params: {'subjectNo': subjectVal, reload: true},
        query: {title: subjectName, sid: subjectVal}
      })
    },
    librarySearch() {
      // 캐시 사용 - 초기화 조건 설정
      this.$router.push({
        name: 'LibrarySearch',
        params: {
          reload: true.toString()
        }
      })
    },
    async newContList () {
      // 신규 콘텐츠 조회 api 호출부
      await store.dispatch('getNewLibraryList', null)
          .then(res => {
            if (res.success) {
              this.newitems = res.data
            } else {
              console.error(res.msg)
            }
          })
          .catch(() => {
          })
          .finally(() => {
          })
    },
    async readList() {
      this.isLoading = true
      await store.dispatch('getLibraryList', this.$_payload('so', [{subjectLimit: this.subjectLimit}]))
        .then(res => {
          if (res.success) {
            const resultData = res.data.contents
            const subjectsCount = res.data.subjectsCount // 주제별 총 카운트
            this.items = resultData
            this.sbitems = [...new Map(resultData.map(item => [item.subject, {
              subject: item.subject,
              subjectNm: item.subjectNm,
              subjectCount: subjectsCount.filter(x => x.subject === item.subject)[0].subjectCount
            }])).values()];

            this.sbitems.sort(function (a, b) {
              return a.subject - b.subject;
            })
          } else {
            console.log('실패 = ', res.msg)
          }
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    async getRecommendedLibList() {
      await store.dispatch('getRecommendedLibList', this.$_payload('so', [{subjectLimit: 20}]))
          .then(res => {
            if (res.success) {
              this.recommendedLibList = res.data
            }
          })
    }
  }
}
</script>
